<template>
  <section class="container">
    <h1>Honor</h1>
    <div class="list">
      <div v-for="item in honor.list" :key="item.id" class="item animate__animated animate__fadeIn">
        <div class="img">
          <img :src="$baseURL + item.thumb" :alt="item.title" />
        </div>
        <div class="name">{{ item.title }}</div>
      </div>
      <Loading v-show="loading"></Loading>
    </div>
    <Pages @numberChange="numberChange" :last="honor.page_count"></Pages>
  </section>
</template>

<script>
import service from "@/assets/js/service";

export default {
  data() {
    return {
      loading: false,
      honor: {
        page_count: 1,
        list: [],
      },
    };
  },
  methods: {
    numberChange(number) {
      this.aboutHonor(number);
    },
    async aboutHonor(number) {
      this.loading = true;
      let res = await service.aboutHonor({ page: number });
      this.loading = false;
      if (res.code == 1) this.honor = res.data.honor;
    },
  },
  created() {
    this.aboutHonor(1);
  },
};
</script>

<style lang="less" scoped>
section {
  h1 {
    font-size: 30px;
  }

  .list {
    position: relative;
    margin: 30px auto;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 45px;

    .item {
      .img {
        width: 100%;
        background: #f6f6f8;
        padding: 20px 0;
        text-align: center;

        img {
          width: 30%;
          height: 100%;
          object-fit: contain;
          object-position: center;
        }
      }

      .name {
        text-align: center;
        margin-top: 20px;
      }
    }
  }
}

@media (max-width: 1000px) {
  section {
    .list {
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 20px;

      .item {
        .name {
          margin-top: 5px;
        }
      }
    }
  }
}

@media (max-width: 500px) {
  section {
    .list {
      grid-template-columns: repeat(1, 1fr);
    }
  }
}
</style>